import { render } from "./BaseDialog.vue?vue&type=template&id=2b26d1a2&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=2b26d1a2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2b26d1a2"

export default script